import { render, staticRenderFns } from "./ProjetoTipo.vue?vue&type=template&id=632457e4&"
import script from "./ProjetoTipo.vue?vue&type=script&lang=js&"
export * from "./ProjetoTipo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports